const QUERY_KEY = {
  ACG: {
    PHASE_1: {
      LIST_EMAIL_EXCLUSION_JOBS: 'acg_phase_1_list_email_exclusion_jobs',
      GET_EMAIL_EXCLUSION_JOB: 'acg_phase_1_get_email_exclusion_job',
    },
  },
};

export default QUERY_KEY;
